import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/utils";


interface ConditionalRouteProps{
  component: React.ComponentType;
  isPrivate?: boolean
}
const ConditionalRoute: React.FC<ConditionalRouteProps> =( {

  component: Component,
  isPrivate = false,
})=>{
  // const { component: Component, isPrivate = false } = props;
  const isAuthenticated = !!getToken('access_token');

  // if (isPrivate && !isAuthenticated) {
  //   return <Navigate to="/login" />;
  // } else if (isPrivate && !isAuthenticated) {
  //   return <Navigate to="/Warehouse" />;
  // }
  return <Component />;
};

export default ConditionalRoute;
